// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"8f66a22e","154":"7b24c2c5","213":"71743c5d","248":"bf449330","391":"bd9567df","419":"d16a53ab","599":"078426ac","898":"7b8e37ac","941":"3304906d","951":"e339c7e2"}[chunkId] + ".chunk.js";
};